import React, { useState } from 'react';
import styled from '@emotion/styled';
import StyledInput from './StyledInput';
import { EyeFill, EyeSlashFill } from '@emotion-icons/bootstrap';

const PasswordInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ToggleIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 30px;
    height: 30px;
    padding: 5px;
    color: var(--raisin-black);
  }
`;

const PasswordInput = (props: React.InputHTMLAttributes<HTMLInputElement>) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <PasswordInputWrapper>
      <StyledInput
        {...props}
        type={showPassword ? 'text' : 'password'}
        style={{ paddingRight: '48px' }}
      />
      <ToggleIcon onClick={togglePasswordVisibility}>
        {showPassword ? <EyeFill /> : <EyeSlashFill />}
      </ToggleIcon>
    </PasswordInputWrapper>
  );
};

export default PasswordInput;
